import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';
import {getActuallyDate} from 'util/date';

const _createFetchParams = language => ({
    language
});

module.exports = {
    createFetchParams: _createFetchParams,
    ...storeModuleFactory({
        name:                'issue',
        endpoint:            endpoints.serviceNow.detailIssueEndpoint,
        timeout:             TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        transformEntitiesFn: item => ({
            id:           item.id,
            serviceNowId: item.number,
            creationUser: {
                firstName: item.opened_by.name,
                id:        item.opened_by.id
            },
            requester: {
                firstName: item.requester.name,
                id:        item.requester.id
            },
            creationUserName: item.opened_by.name,
            title:            item.title,
            description:      item.description,
            watchList:        item.watch_list,
            created:          item.created_date,
            datetime:         getActuallyDate(item.creation_date),
            datos:            item.opened_by,
            accountName:      item.company ? item.company.name : '',
            totalMessages:    item.comments ? item.comments.length : '',
            activity:         item.comments ? item.comments.map(itemActivity => ({
                id:        itemActivity.sys_id,
                name:      itemActivity.opened_by.name,
                value:     itemActivity.description,
                createdOn: getActuallyDate(itemActivity.creation_date)
            })) : [],
            serviceOfferingText: item.service_offering ? item.service_offering.name : '',
            serviceOffering:     item.service_offering && {
                id:   item.service_offering.id,
                name: item.service_offering.name
            },
            state:       item.state ? item.state.id : '',
            impact:      item.impact ? item.impact.id : '',
            viewState:   item.state ? item.state : '',
            viewImpact:  item.impact ? item.impact : '',
            attachments: item.attachments ? item.attachments.map(itemAttachment => ({
                fileName:    itemAttachment.file_name,
                sysId:       itemAttachment.sys_id,
                contentType: itemAttachment.content_type,
                size:        itemAttachment.size
            })) : []
        })
    })
};





// WEBPACK FOOTER //
// ./src/modules/store/issue.js